import { useState } from 'react'

import EquipmentProfileListComponent from 'components/EquipmentProfile/EquipmentProfileListComponent'
import EquipmentProfileModifyComponent from 'components/EquipmentProfile/EquipmentProfileModifyComponent'

export default function EquipmentProfileTab() {

    const [tabRoute, setTabRoute] = useState('/equipmentProfile/view')
    const [navigationProps, setNavigationProps] = useState(null)

    const ViewNavigationAction = (route, navigationProps) => {
        setNavigationProps(navigationProps)
        setTabRoute(route)
    }

    const ModifyNavigationAction = (route) => {
        setTabRoute(route)
        setNavigationProps(null)
    }

    if (tabRoute === '/equipmentProfile/view') {
        return (
            <EquipmentProfileListComponent NavigationAction={ViewNavigationAction} />                
        )
    }

    if (tabRoute === '/equipmentProfile/modify') {

        if (navigationProps === null) return <></>

        return (
            <EquipmentProfileModifyComponent 
                modificationKey={navigationProps.state.modificationKey}
                propEquipmentProfile={navigationProps.state.propEquipmentProfile}
                NavigationAction={ModifyNavigationAction}
            />
        )
    }
}